/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2026 Rochester Software Associates (service@rocsoft.com)
 */



import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';


const ScrollOnRouteChange = () => {
    const { pathname } = useLocation();
    const [prevPath, setPrevPath] = useState(pathname);
    useEffect(() => {
        const isCatalogRedirect = pathname.startsWith('/catalog') && prevPath.startsWith('/catalog');
        const isCatalogItemDetailsPage = pathname.startsWith('/catalog/item');

        if (!isCatalogRedirect || isCatalogItemDetailsPage) {
            // scrollTo(0,0) with smooth behavior does not work with firefox at the time of writing
            window.scrollBy(-window.scrollX, -window.scrollY);
        }
        setPrevPath(pathname);
    }, [pathname, prevPath, setPrevPath]);
    return null;
};

export default ScrollOnRouteChange;